type VibrateType = {
  duration: number | number[];
};

export function vibrate({ duration }: VibrateType) {
  if (typeof window !== "undefined" && "vibrate" in navigator) {
    navigator.vibrate(duration);
  }
}
